class Breadcrumb {
  public element: HTMLElement | null;
  public IS_SECOND_VP: string = 'is-second-vp';

  bindings() {
    window.addEventListener('scroll', () => {
      if (window.scrollY < window.innerHeight * 2 / 3) {
        if (this.element?.classList.contains(this.IS_SECOND_VP)) {
          this.element?.classList.remove(this.IS_SECOND_VP);
          document.body.classList.remove(this.IS_SECOND_VP);
        }
      } else if (!this.element?.classList.contains(this.IS_SECOND_VP)) {
        this.element?.classList.add(this.IS_SECOND_VP);
        document.body.classList.add(this.IS_SECOND_VP);
      }
    });
  }

  cache() {
    this.element = document.querySelector('.a-breadcrumb');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Breadcrumb;
